import { action } from '@ember/object';
import { tracked } from '@glimmer/tracking';

import type { PopupData } from 'webapp-types';
import { TemplateObjectType } from 'webapp/enums/enums';

import CommonPopupsConfirmComponent from 'webapp/components/common/popups/confirm';
import CommonUiIconComponent from 'webapp/components/common/ui-icon';
import FormCheckboxComponent from 'webapp/components/form/checkbox';
import FormInputComponent from 'webapp/components/form/input';
import RowErrorComponent from 'webapp/components/row-error';
import SubmitButtonComponent from 'webapp/components/submit-button';

export default class AccountTemplatePopupDeleteConfirmComponent extends CommonPopupsConfirmComponent<PopupData.Templates.AccountDeleteConfirm> {
	@tracked keepBoardTemplates = true;

	get isBoardLoopTemplate() {
		return this.popupData.objectType === TemplateObjectType.BOARD_LOOP;
	}

	@action
	changeKeepBoardTemplates(value: boolean): void {
		this.keepBoardTemplates = value;
	}

	override confirmAndClose() {
		this.popupData.onConfirm(this.keepBoardTemplates);
		this.close();
	}
	<template>
		<div class="content">
			<div class="header {{this.titleClass}}">
				<CommonUiIconComponent @name="AlertFill" @size="lg" />
			</div>
			<span class="title">{{{this.title}}}</span>
			{{#if this.text}}
				<p>
					{{{this.text}}}
					{{#if this.confirmWord}}
						<span>Type {{this.confirmWord}} to confirm:</span>
					{{/if}}
				</p>
			{{/if}}
			{{#if this.isBoardLoopTemplate}}
				<div class="row">
					<FormCheckboxComponent
						@name="keep_board_templates"
						@selected={{this.keepBoardTemplates}}
						@label="Delete only the loop and keep dashboards as account templates"
						@onChange={{this.changeKeepBoardTemplates}}
					/>
				</div>
			{{/if}}
			{{#if this.confirmWord}}
				<div class="row">
					<FormInputComponent
						name="confirmword"
						maxlength="50"
						@value={{this.typedWord}}
						@insertNewline={{this.confirm}}
					/>
					<RowErrorComponent @items={{this.errors.typedWord}} />
				</div>
			{{/if}}
			<div class="controls2">
				<div class="controls2__right">
					<SubmitButtonComponent
						data-testid="test-confirmPopupCancelActionButton"
						@text={{this.cancelAction}}
						@theme="grey-empty"
						@noDelay={{true}}
						@submitInProgress={{this.submitInProgress}}
						@onTrigger={{this.close}}
					/>
					<SubmitButtonComponent
						data-testid="test-confirmPopupConfirmActionButton"
						@text={{this.confirmAction}}
						@theme={{this.buttonTheme}}
						@noDelay={{true}}
						@submitInProgress={{this.submitInProgress}}
						@onTrigger={{this.confirm}}
					/>
				</div>
			</div>
		</div>
	</template>
}
